"use client";

import { Dispatch, SetStateAction, useCallback } from "react";
import { ShareBarEvents, trackEvent } from "@punchup/analytics";

import { ModalOrDrawer } from "./ModalOrDrawer";
import ShareBar from "../sharebar/ShareBar";

export interface ShareDataWithUrl extends ShareData {
  url: string;
}

interface ShareModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  shareData: ShareDataWithUrl;
}

export default function ShareModal({
  open,
  setOpen,
  shareData,
}: ShareModalProps) {
  const onCloseModal = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleClose = () => {
    trackEvent(ShareBarEvents.CLOSED_SHARE_BAR);
    onCloseModal();
  };

  return (
    <ModalOrDrawer isOpen={open} onOpenChange={setOpen}>
      <div className="flex flex-col gap-3">
        <h2 className="font-semibold text-lg">Share</h2>
        <ShareBar shareData={shareData} onLinkCopied={handleClose} />
      </div>
    </ModalOrDrawer>
  );
}
